<template>
  <v-row justify="center" class="blank-widget">
    <v-dialog v-model="dialog" width="600px" class="remove-shadow" dark>
      <template v-slot:activator="{ on }" class="add-widget">
        <v-btn color="white" icon v-on="on">
          <v-icon color="white" v-on="on">mdi-view-grid-plus-outline</v-icon>
        </v-btn>
      </template>
      <v-row>
        <v-col cols="6" sm="12" md="6">
          <v-card class="mx-auto" max-width="240" outlined>
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">
                  {{ $t('widgets.clock.name') }}
                </v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="white">mdi-clock-outline</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>{{ $t('widgets.clock.desc') }}</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small @click="changeWidget('clock')">
                {{ $t('dialogs.changeWidget.selectBtn') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="6" sm="12" md="6">
          <v-card class="mx-auto" max-width="240" outlined>
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">
                  {{ $t('widgets.weather.name') }}
                </v-list-item-title>
              </v-list-item-content>
              <v-icon size="30" color="white darken-2">
                mdi-weather-partly-snowy-rainy
              </v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>{{ $t('widgets.weather.desc') }}</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small @click="changeWidget('weather')">
                {{ $t('dialogs.changeWidget.selectBtn') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="6" sm="12" md="6">
          <v-card class="mx-auto" max-width="240" outlined>
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">
                  {{ $t('widgets.wifi.name') }}
                </v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="white lighten-3">mdi-wifi</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>{{ $t('widgets.wifi.desc') }}</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small @click="changeWidget('wifi')">
                {{ $t('dialogs.changeWidget.selectBtn') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="6" sm="12" md="6">
          <v-card class="mx-auto" max-width="240" outlined>
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">
                  {{ $t('widgets.news.name') }}
                </v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="white">mdi-newspaper</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>{{ $t('widgets.news.desc') }}</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small @click="changeWidget('news')">
                {{ $t('dialogs.changeWidget.selectBtn') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <!-- <v-col cols="6" sm="12" md="6">
          <v-card
            class="mx-auto"
            max-width="240"
            outlined
          >
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">{{ $t('widgets.todo.name') }}</v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="white">mdi-format-list-checks</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>{{ $t('widgets.todo.desc') }}</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small  @click="changeWidget('todo')">{{ $t('dialogs.changeWidget.selectBtn') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col> -->
        <!-- <v-col cols="6" sm="12" md="6">
          <v-card
            class="mx-auto"
            max-width="240"
            outlined
          >
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">Live Transport</v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="white">mdi-train-car</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>Live transport times</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small  @click="changeWidget('peopleInSpace')">{{ $t('dialogs.changeWidget.selectBtn') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col> -->
        <!-- <v-col cols="6" sm="12" md="6">
          <v-card
            class="mx-auto"
            max-width="240"
            outlined
          >
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">Uber</v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="white">mdi-train-car</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>Uber arrival time estimate</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small  @click="changeWidget('peopleInSpace')">{{ $t('dialogs.changeWidget.selectBtn') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col> -->
        <v-col cols="6" sm="12" md="6">
          <v-card class="mx-auto" max-width="240" outlined>
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">
                  {{ $t('widgets.quotes.name') }}
                </v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="white">mdi-comment-quote</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>{{ $t('widgets.quotes.desc') }}</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small @click="changeWidget('quotes')">
                {{ $t('dialogs.changeWidget.selectBtn') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <!-- <v-col cols="6" sm="12" md="6">
          <v-card class="mx-auto" max-width="240" outlined>
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">Google Search</v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="white">mdi-google</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>Add Google Search</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small @click="changeWidget('peopleInSpace')">
                {{ $t('dialogs.changeWidget.selectBtn') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col> -->
        <v-col cols="6" sm="12" md="6">
          <v-card class="mx-auto" max-width="240" outlined>
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">
                  {{ $t('widgets.currency.name') }}
                </v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="gray">mdi-cash-multiple</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>{{ $t('widgets.currency.desc') }}</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small @click="changeWidget('currency')">
                {{ $t('dialogs.changeWidget.selectBtn') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="6" sm="12" md="6">
          <v-card class="mx-auto" max-width="240" outlined>
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">
                  {{ $t('widgets.peopleInSpace.name') }}
                </v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="white">mdi-space-station</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>{{ $t('widgets.peopleInSpace.desc') }}</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small @click="changeWidget('peopleInSpace')">
                {{ $t('dialogs.changeWidget.selectBtn') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <!-- <v-col cols="6" sm="12" md="6">
          <v-card class="mx-auto" max-width="240" outlined>
            <v-list-item one-line>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 mb-1">Crypto</v-list-item-title>
              </v-list-item-content>

              <v-icon size="30" color="gray">mdi-money</v-icon>
            </v-list-item>
            <v-card-text class="pt-0 pb-0">
              <div>Add Crypto</div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text small @click="changeWidget('crypto')">
                {{ $t('dialogs.changeWidget.selectBtn') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col> -->
      </v-row>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'ChangeWidget',
  props: {
    position: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    changeWidget(widget) {
      this.dialog = false
      this.$store.dispatch('dashboard/updateWidgetType', {
        [this.position]: widget
      })
    }
  }
}
</script>

<style lang="scss">
.v-dialog {
  box-shadow: none;
}
.blank-widget {
  button {
    opacity: 0.5;
  }
  &:hover {
    cursor: pointer;
    button {
      opacity: 0.5;
      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
